import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { PwrDistroAnswerFieldsets } from 'containers/search/SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

export function AnswerSearch(props) {
  const clientProps = useContext(ClientContext);

  if (clientProps && !getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      /\/answers-search(?=\/|$)/,
      '/answers'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label="Answers"
      primaryFieldsets={PwrDistroAnswerFieldsets.primaryFieldsets}
      extraFieldsets={PwrDistroAnswerFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/AnswerSearch.js